export const environment = {
  production: false,
  baseUrl: 'https://api.kartasoft.co/',
  apiUrl: 'https://api.kartasoft.co/api/',
  platformUrl: 'https://staging.kartasoft.co/'
};

